/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react"
import useTranslationHook, {
  englishLanguage,
} from "../../../hooks/use-translation.hook"
import styled from "styled-components"
import { InvinsibleBackdrop } from "../language-picker/language-picker.component"
import { AppFunctionComponent } from "../../../types"

export const DropdownButton = styled.div`
  border: none;
  cursor: pointer;
  position: relative;
  span {
    display: inline-block;
    font-size: 14px;
  }
  z-index: 1;
`

const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  padding: 10px 20px;
  width: 190px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06);
  z-index: 10;
  transition: 0.3s ease-in-out;
  right: -20px;
  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
    right: 0;
    top: 80%;
    z-index: 2;
  }
`

const DropdownItem = styled.div`
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Facto;
  font-size: 14px;
  font-weight: 500;
  line-height: 13px;
  letter-spacing: 0.115em;
  text-align: left;
  margin-bottom: 10px;

  &:hover {
    text-decoration: underline;
  }
`

export const CountryIcon = styled.img`
  position: relative;
  object-fit: cover;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  display: inline;
  /* top: 4px; */
  padding: unset;
  object-position: left;
`
const CountryIconInline = styled(CountryIcon)`
  margin-left: unset;
  top: unset;
`

const SimpleLanguagePicker: AppFunctionComponent = ({ className }) => {
  const [active, setActive] = useState(false)
  const { language, translationOptions, changeLanguageManually } =
    useTranslationHook()
  const [currentLang, setCurrentLang] = useState(translationOptions[0])

  const setLanguage = (value: string) => {
    changeLanguageManually(value)
  }

  useEffect(() => {
    setActive(false)
    setCurrentLang(
      translationOptions.find(({ value }) => {
        return value === language
      }) || englishLanguage
    )
  }, [language, translationOptions])
  return (
    <>
      <DropdownButton
        className={className}
        onClick={() => setActive((prev) => !prev)}
      >
        <CountryIcon src={currentLang.image.src} alt={currentLang.image.alt} />
      </DropdownButton>
      {active && (
        <>
          <DropdownContent>
            {translationOptions
              .filter(({ value }) => value !== language)
              .map(({ value, label, image }, i) => {
                return (
                  <DropdownItem key={i} onClick={() => setLanguage(value)}>
                    <CountryIconInline src={image.src} />
                    {label}
                  </DropdownItem>
                )
              })}
          </DropdownContent>
          <InvinsibleBackdrop onClick={() => setActive(false)} />
        </>
      )}
    </>
  )
}

export default SimpleLanguagePicker
